(ns client-portal.client.voice-insights.sessions.utterances.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [client-portal.client.voice-insights.sessions.data :as sessions.d]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.voice-insights.tag-data :refer [remove-internal-tags]]
            [shared.core.reactive :as re]
            [shared.core.util :as util]
            [shared.core.time :as time]))

(def root-path sessions.d/utterances-path)
(def list-path sessions.d/utterances-list-path)
(def page-size 100)

(defn build-utterances-list-page-path [page]
  (conj list-path page))

(defn current-max-page [db]
  (some->> (get-in db list-path)
           (util/when-not-loading)
           (keys)
           (apply max)))

(defn utterances-list-data-has-more? [db]
  (let [list-data (get-in db list-path)
        max-page (current-max-page db)]
    (some->> (get (util/when-not-loading list-data) max-page)
             (util/when-not-loading)
             (count)
             (<= page-size))))

(re/reg-sub :sessions/utterances-list-data-has-more?- utterances-list-data-has-more?)

(defn utterances-list-loading? [db]
  (let [list-data (get-in db list-path)]
    (or (util/loading? list-data) (some-> list-data (get 0) (util/loading?)))))

(re/reg-sub :sessions/utterances-list-loading?- utterances-list-loading?)

(defn utterances-list-next-page-loading? [db]
  (let [page (current-max-page db)]
    (and (pos? page) (util/loading? (get-in db (build-utterances-list-page-path page))))))

(re/reg-sub :sessions/utterances-list-next-page-loading?- utterances-list-next-page-loading?)

(defn list-next-page [db]
  (some-> (current-max-page db) (inc)))

(re/reg-sub :sessions/utterances-list-next-page- list-next-page)

(defn transf-utterances-resp [resp]
  (or (some->> resp :body (util/->kebab-case-keywords)
               (mapv #(assoc % :conversation-ts-raw (:conversation-ts %)
                               :conversation-ts (time/reformat-date-str (:conversation-ts %) "M/d/yy h:mm A")
                               :transcript (vi.d/clean-bad-words (:transcript %))
                               :tag-details (->> (:tag-details %)
                                                 (remove-internal-tags)
                                                 (mapv (fn [t] (update t :description vi.d/clean-bad-words))))
                               :offset (when-let [start (:start %)]
                                         (time/seconds->format (js/Math.round (/ start 1000)))))))
      []))

(re/reg-auth0-loader
  :sessions/load-utterances-list-data
  (fn [[[_ {:keys [page]}]] _]
    (build-utterances-list-page-path (or page 0)))
  (fn [db [_ {:keys [page]} _]]
    (when (and (not (utterances-list-next-page-loading? db))
               (not (utterances-list-loading? db)))
      (when (concepts.d/current-concept-id db)
        (let [last-loaded (some-> (util/when-not-loading (get-in db list-path))
                                  (get (or (dec (or page 0)) 0))
                                  (last))]
          {:method :post
           :url "/api/vi/utterances/list"
           :json-params (merge (sessions.d/base-query-args db
                                                           {:end-date (:conversation-ts-raw last-loaded)
                                                            :limit page-size})
                               {:end-date-start-ms (:start last-loaded)})}))))
  :transf transf-utterances-resp
  :error-transf (fn [] []))

(re/reg-sub
  :sessions/utterances-list-
  (fn [db]
    (let [current-list (get-in db list-path)
          cur-page (if (util/loading? current-list) 0 (current-max-page db))]
      (if (nil? current-list)
        (re/dispatch-load (conj [:sessions/load-utterances-list-data
                                 [nil {:page (or (some-> cur-page (inc)) 0)}]]))
        current-list))))

(re/reg-sub
  :sessions/utterances-list-flattened-
  :<- [:sessions/utterances-list-]
  #(if (or (util/loading? %) (some-> (when (map? %) (util/loading? (get % 0)))))
     :loading
     (sessions.d/list->flattened-list %)))
